import React from "react";

export default function BtnDelete({id}) {
    return <a className="btn-flat btn-delete" req-id={id}>
        <i className="material-icons">close</i>
    </a>
}